export default "__VITE_ASSET__C$jY2pX5__"